// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610021104/js/" + chunkId + "." + {"44":"6ec40fc5","225":"44a24bf3","481":"0ada0eaf","486":"8b08a1c5","770":"5db64f08"}[chunkId] + ".0.35538922658034466.chunk.js";
};